import { useState, useEffect, useRef } from 'react';
import { createChart } from 'lightweight-charts';
import { Box } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import "./tip.css"
import InfoIcon from '@mui/icons-material/Info'; // import ไอคอน Information
import ShowChartIcon from '@mui/icons-material/ShowChart';
import FontLoader from '../../components/FontLoader';
import { showLoader, hideLoader } from '../../components/Preloading2';
import { useTheme } from '@mui/material';

const CHART_COLORS = {
  GOLD: '#95fe51',
  TRENDS: '#0296E5',
  VIX: '#DA9551',
  DXY: '#E05920',
  US10YY: '#009BA0'
};

function FiveChart_v4() {
  const theme = useTheme();
  const chartContainerRef = useRef(null);
  const [data, setData] = useState([]);

  const chartContainerRef2 = useRef(null);
  const [data2, setData2] = useState([]);

  const chartContainerRef3 = useRef(null);
  const [data3, setData3] = useState([]);

  const chartContainerRef4 = useRef(null);
  const [data4, setData4] = useState([]);

  const chartContainerRef5 = useRef(null);
  const [data5, setData5] = useState([]);

  useEffect(() => {
    showLoader();
  }, []);
  // Fetch XAUUSD


  const uri = `${window.config.base_api_url}`;
  useEffect(() => {
    fetch(uri + '/fivechart?broker_name=XAUUSD')
      .then(response => response.json())
      .then(data => setData(data.data))
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  // Fetch SPDR
  useEffect(() => {
    fetch(uri + '/fivechart?broker_name=SPDR')
      .then(response => response.json())
      .then(data => setData2(data.data))
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  // Fetch VIX
  useEffect(() => {
    fetch(uri + '/fivechart?broker_name=VIX')
      .then(response => response.json())
      .then(data => setData3(data.data))
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  // Fetch DXY
  useEffect(() => {
    fetch(uri + '/fivechart?broker_name=DXY')
      .then(response => response.json())
      .then(data => setData4(data.data))
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  // Fetch US10YY
  useEffect(() => {
    fetch(uri + '/fivechart?broker_name=US10YY')
      .then(response => response.json())
      .then(data => setData5(data.data))
      .catch(error => console.error('Error fetching data:', error));
  }, []);


  const charts = [];
  const seriesList = [];

  // Utility functions
  function syncCrosshair(chart, series, dataPoint) {
    if (dataPoint) {
      chart.setCrosshairPosition(dataPoint.value, dataPoint.time, series);
    } else {
      chart.clearCrosshairPosition();
    }
  }

  function getCrosshairDataPoint(series, param) {
    if (!param.time) return null;
    const dataPoint = param.seriesData.get(series);
    return dataPoint || null;
  }

  function createChartWithOptions(containerRef, data, watermarkText, color, rightPriceScale, rightOffset) {
    if (!data) {
      return;
    };
    // rightPriceScale: {
    //   borderVisible: false,
    // },
    if (containerRef.current) {
      containerRef.current.innerHTML = '';
    }

    const commonOptions = {
      width: containerRef.current.clientWidth,
      height: containerRef.current.clientHeight,
      // layout: {
      //   background: {
      //       type: 'solid', 
      //       color: '#0D2233' 
      //   },
      //   textColor: '#FFFFFF', 
      // },
      timeScale: { rightOffset: 10 },
      layout: {
        attributionLogo: false,
        background: {
          type: 'solid',
          color: theme.palette.background.default
        },
        textColor: theme.palette.text.primary,
      },
      grid: {
        horzLines: { color: theme.palette.divider },
        vertLines: { color: theme.palette.divider },
        // vertLines: { color: theme.palette.neutral.dark  },
        // vertLines: {color:'red'},
        // horzLines: { color: theme.palette.neutral.dark  },
      },

    }

    const chart = createChart(containerRef.current, commonOptions);


    chart.priceScale('right').applyOptions({
      visible: !rightPriceScale ? false : true,
      // textColor: '#F5F5F5',

    });
    chart.priceScale('left').applyOptions({
      visible: false,
      // textColor: '#F5F5F5',

    });

    chart.applyOptions({
      watermark: {
        visible: true,
        fontSize: 30,
        horzAlign: 'center',
        vertAlign: 'center',
        //color: '#C7D0FF',
        // color: 'rgba(255, 255, 255, 0.6)', // สีขาวที่โปร่งใส 30%
        color: theme.palette.chart.watermark,
        text: watermarkText,
        fontFamily: 'Lato, Sans-serif',


      },


    });

    const lineSeries = chart.addLineSeries({ color, lineWidth: 2, priceLineVisible: false, });
    const formattedData = data.map(item => ({
      time: item.time,
      // value: item.value, //อันเดิมอยู่นี่
      value: typeof item.value === "string" ? parseFloat(item.value) || 0 : item.value, // บังคับแปลงจาก string เป็น ตัวเลข
    }));

    lineSeries.applyOptions({
      priceFormat: {
        type: 'custom',
        formatter: (price) => {
          return price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      }
      // priceFormat: {
      //   type: 'custom',
      //   formatter: (price) => {
      //     let shortenedPrice = price / 1_000_000_000;
      //     return shortenedPrice.toLocaleString('en-US', {
      //       minimumFractionDigits: 1,
      //       maximumFractionDigits: 1,
      //     }) + 'B';

      //   },
      // },
    });

    // console.log("data is", formattedData)

    lineSeries.setData(formattedData);

    // ฟังก์ชันการปรับขนาด Chart อัตโนมัติ
    const resizeObserver = new ResizeObserver(() => {
      chart.applyOptions({
        width: containerRef.current.clientWidth,
        height: containerRef.current.clientHeight,
      });
    });

    resizeObserver.observe(containerRef.current);

    return { chart, lineSeries };
  }

  // Create charts
  useEffect(() => {
    const all_size = [data.length, data2.length, data3.length, data4.length, data5.length]
    const min = Math.min(...all_size);
    let temp_data = []
    // if (min == data.length){
    //   temp_data = data
    // } else if (min == data2.length) {
    //   temp_data = data2
    // } else if (min == data3.length) {
    //   temp_data = data3
    // } else if (min == data4.length) {
    //   temp_data = data4
    // } else {
    //   temp_data = data5
    // }
    temp_data = data4


    const getCommonDates = (data1, data2, data3, data4, data5) => {
      const dates1 = new Set(data1.map(item => item.time));
      const dates2 = new Set(data2.map(item => item.time));
      const dates3 = new Set(data3.map(item => item.time));
      const dates4 = new Set(data4.map(item => item.time));
      const dates5 = new Set(data5.map(item => item.time));
      return [...dates1].filter(date => dates2.has(date) && dates3.has(date) && dates4.has(date) && dates5.has(date));
    }

    const filterDataByCommonDates = (data, commonDates) => {
      return data.filter(item => commonDates.includes(item.time));
    }

    const commonDates = getCommonDates(data, data2, data3, data4, data5);
    const new_data = filterDataByCommonDates(data, commonDates);
    const new_data2 = filterDataByCommonDates(data2, commonDates)
    const new_data3 = filterDataByCommonDates(data3, commonDates)
    const new_data4 = filterDataByCommonDates(data4, commonDates)
    const new_data5 = filterDataByCommonDates(data5, commonDates)

    // new_data3.push({ 'time': '2026-02-04', 'value': 12 })
    // function compare(a, b) {
    //   if (a.time < b.time) {
    //     return -1;
    //   }
    //   if (a.time > b.time) {
    //     return 1;
    //   }
    //   return 0;
    // }
    // new_data3.sort((a, b) => new Date(a) - new Date(b));
    // console.log(new_data3);

    const chart1 = createChartWithOptions(chartContainerRef, new_data, 'Gold (COMEX)', CHART_COLORS.GOLD, true);
    const chart2 = createChartWithOptions(chartContainerRef2, new_data2, 'Trends', CHART_COLORS.TRENDS, true);
    const chart3 = createChartWithOptions(chartContainerRef3, new_data3, 'VIX', CHART_COLORS.VIX, true);
    const chart4 = createChartWithOptions(chartContainerRef4, new_data4, 'DXY', CHART_COLORS.DXY, true);
    const chart5 = createChartWithOptions(chartContainerRef5, new_data5, 'US10YY', CHART_COLORS.US10YY, true);

    // const chart1 = createChartWithOptions(chartContainerRef, data, 'Gold (COMEX)', CHART_COLORS.GOLD, true);
    // const chart2 = createChartWithOptions(chartContainerRef2, data2, 'Trends', CHART_COLORS.TRENDS);
    // const chart3 = createChartWithOptions(chartContainerRef3, data3, 'VIX', CHART_COLORS.VIX);
    // const chart4 = createChartWithOptions(chartContainerRef4, data4, 'DXY', CHART_COLORS.DXY);
    // const chart5 = createChartWithOptions(chartContainerRef5, data5, 'US10YY', CHART_COLORS.US10YY);

    if (chart1) charts.push(chart1.chart);
    if (chart2) charts.push(chart2.chart);
    if (chart3) charts.push(chart3.chart);
    if (chart4) charts.push(chart4.chart);
    if (chart5) charts.push(chart5.chart);

    if (chart1) seriesList.push(chart1.lineSeries);
    if (chart2) seriesList.push(chart2.lineSeries);
    if (chart3) seriesList.push(chart3.lineSeries);
    if (chart4) seriesList.push(chart4.lineSeries);
    if (chart5) seriesList.push(chart5.lineSeries);

    // Synchronize crosshair and visible logical range
    charts.forEach((chart, index) => {

      chart.subscribeCrosshairMove(param => {
        const dataPoint = getCrosshairDataPoint(seriesList[index], param);
        charts.forEach((otherChart, otherIndex) => {
          if (otherChart !== chart) {
            syncCrosshair(otherChart, seriesList[otherIndex], dataPoint);
          }
        });
      });

      chart.timeScale().subscribeVisibleLogicalRangeChange(timeRange => {
        charts.forEach(otherChart => {
          if (otherChart !== chart) {
            otherChart.timeScale().setVisibleLogicalRange(timeRange);
          }
        });
      });
    });



    if ([data, data2, data3, data4, data5].every(d => d?.length > 0)) {
      hideLoader();
    }



    return () => {
      charts.forEach(chart => chart.remove());
    };
  }, [data, data2, data3, data4, data5]);

  const labelStyle = {
    position: 'absolute',
    top: 10,
    right: 10,
    zIndex: 10,
    bgcolor: '#212B3B', // สีพื้นหลังน้ำเงินเข้ม (ตามรูป)
    padding: '4px 12px',
    borderRadius: '20px', // ความมนแบบ Pill shape
    display: 'flex',
    alignItems: 'center',
    gap: '6px', // ระยะห่างระหว่างแต่ละชิ้นส่วน
    boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
    cursor: 'default',
    border: '1px solid #2A3648' // ขอบจางๆ (Optional)
  };


  const LabelContent = (
    <>

      {/* <Box sx={{ width: 16, height: 2, bgcolor: '#FFFFFF', borderRadius: 1 }} />
      

      <Box component="span" sx={{ color: '#FFFFFF', fontSize: '12px', fontWeight: 500 }}>
        Close
      </Box>


      <Box sx={{ width: 24, height: 2, bgcolor: '#009933', borderRadius: 1 }} />
      

      <Box component="span" sx={{ color: '#009933', fontSize: '12px', fontWeight: 500 }}>
        Flow
      </Box>


      <Box sx={{ width: '1px', height: 14, bgcolor: '#4B5E76', mx: 0.5 }} />

 
      <Box sx={{ width: 14, height: 12, bgcolor: '#B0B0B0', borderRadius: '1px' }} /> */}
    </>
  );


  return (
    <Box sx={{ padding: 2, fontFamily: 'Lato, Sans-serif', bgcolor: '#1C2232', minHeight: '100vh' }}>


      <Box
        sx={{
          width: "100%",
          height: 280,
          borderRadius: 3,
          overflow: "hidden",
          marginBottom: 1,
          boxShadow: "0px 2px 5px rgba(255, 255, 255, 0.5)",
          border: "2px solid black",
          position: "relative",
          // bgcolor: "red" 
          bgcolor: "#0D2233"
        }}
      >

        <Box ref={chartContainerRef} sx={{ width: '100%', height: '100%' }} />

        {/* Tooltip */}
        {/* <div className="item-hints" style={{ position: "absolute", top: "85px", right: "1161px" }}>
          <div className="hint" data-position="4">
            <span className="hint-radius"></span>
            <span className="hint-dot">
              <InfoIcon style={{ fontSize: 30, color: "#000" }} /> {/* แสดงไอคอน Information */}
        {/* </span>
            <div className="hint-content do--split-children">
              <p>Is Price</p>
            </div>
          </div> */}

      </Box>


      <Box sx={{ display: "flex", gap: 1, marginBottom: 1 }}>
        {/* กราฟ 2 */}
        <Box
          sx={{
            flex: 1,
            height: 280,
            borderRadius: 3,
            overflow: "hidden",
            boxShadow: "0px 2px 5px rgba(255, 255, 255, 0.5)",
            border: "2px solid black",
            position: "relative",
            bgcolor: "#0D2233"
          }}
        >
          <Box ref={chartContainerRef2} sx={{ width: '100%', height: '100%' }} />
        </Box>

        {/* กราฟ 3 */}
        <Box
          sx={{
            flex: 1,
            height: 280,
            borderRadius: 3,
            overflow: "hidden",
            boxShadow: "0px 2px 5px rgba(255, 255, 255, 0.5)",
            border: "2px solid black",
            position: "relative",
            bgcolor: "#0D2233"
          }}
        >
          <Box ref={chartContainerRef3} sx={{ width: '100%', height: '100%' }} />
        </Box>
        {/* Tooltip */}
        {/* <div className="item-hints" style={{ position: "absolute", top: "85px", right: "470px" }}>
            <div className="hint" data-position="4">
              <span className="hint-radius"></span>
              <span className="hint-dot">
                <ShowChartIcon style={{ fontSize: 30, color: "#000" }} />
              </span>
              <div className="hint-content do--split-children">
                <p>
                  Up Is <span style={{ color: "green" }}>Good</span> <br />
                  Down Is <span style={{ color: "red" }}>Lose</span>
                </p>
              </div>
            </div>
          </div> */}
      </Box>


      <Box sx={{ display: "flex", gap: 1 }}>
        {/* กราฟ 4 */}
        <Box
          sx={{
            flex: 1,
            height: 280,
            borderRadius: 3,
            overflow: "hidden",
            boxShadow: "0px 2px 5px rgba(255, 255, 255, 0.5)",
            border: "2px solid black",
            position: "relative",
            bgcolor: "#0D2233"
          }}
        >
          <Box ref={chartContainerRef4} sx={{ width: '100%', height: '100%' }} />
          {/* Tooltip */}
          {/* <div className="item-hints" style={{ position: "absolute", top: "85px", right: "470px" }}>
            <div className="hint" data-position="4">
              <span className="hint-radius"></span>
              <span className="hint-dot">
                <ShowChartIcon style={{ fontSize: 30, color: "#000" }} />
              </span>
              <div className="hint-content do--split-children">
                <p>
                  Up Is <span style={{ color: "red" }}>Lose</span> <br />
                  Down Is <span style={{ color: "green" }}>Good</span>
                </p>
              </div>
            </div>
          </div> */}
        </Box>

        {/* กราฟ 5 */}
        <Box
          sx={{
            flex: 1,
            height: 280,
            borderRadius: 3,
            overflow: "hidden",
            boxShadow: "0px 2px 5px rgba(255, 255, 255, 0.5)",
            border: "2px solid black",
            position: "relative",
            bgcolor: "#0D2233"
          }}
        >
          <Box ref={chartContainerRef5} sx={{ width: '100%', height: '100%' }} />

          {/* Tooltip */}
          {/* <div className="item-hints" style={{ position: "absolute", top: "85px", right: "470px" }}>
            <div className="hint" data-position="4">
              <span className="hint-radius"></span>
              <span className="hint-dot">
                <ShowChartIcon style={{ fontSize: 30, color: "#000" }} />
              </span>
              <div className="hint-content do--split-children">
                <p>
                  Up Is <span style={{ color: "red" }}>Lose</span> <br />
                  Down Is <span style={{ color: "green" }}>Good</span>
                </p>
              </div>
            </div>
          </div> */}

        </Box>
      </Box>

    </Box>
  );
}

export default FiveChart_v4;
